<template>
    <div v-if="hasGetData" class="wework-steps-auth">
        <instead-auth v-if="isNew" :is-last-step="isLastStep" @success="onSuccess"></instead-auth>
        <secret-auth v-else :is-last-step="isLastStep" @success="onSuccess"></secret-auth>
    </div>
</template>

<script>
import getCorpInfo from '@/pages/mng/third_account/weworkCombine/api/getCorpInfo';
import SecretAuth from '../../secret-auth';
import InsteadAuth from '../../instead-auth';

export default {
    components: {
        SecretAuth,
        InsteadAuth
    },

    props: {
        isLastStep: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            // 企微是新的绑定方式还是旧的
            isNew: false,
            hasGetData: false
        };
    },

    created() {
        this.getAccountInfo();
    },

    methods: {
        getAccountInfo() {
            getCorpInfo()
                .then(res => {
                    const { isNew } = res || {};
                    this.isNew = isNew;
                    this.hasGetData = true;
                })
                .catch(message => {
                    this.$message.error(message || '获取企业微信账号信息失败');
                });
        },

        onSuccess() {
            this.$emit('stepComplete');
        }
    }
};
</script>
